<template>
  <div class="template">
    <div v-html="rawHtml" class="raw">

    </div>
  </div>
</template>
<script>
import qs from 'qs'
export default {
  data () {
    return {
      rawHtml: null
    }
  },
  created () {
    const search = qs.parse(location.search, { ignoreQueryPrefix: true })
    const id = 'id' in search ? search.id : null
    if (!id) {
      this.$router.push('/email')
      return false
    }
    this.getTemplate(id)
  },
  methods: {
    async getTemplate (id) {
      const res = await this.$http.post(`/emailj/modular`, {
        id
      })
      this.rawHtml = res.data
    }
  }
}
</script>
<style lang="scss" scoped>
.template {
  background: #fff;
  .raw {
    width: fit-content;
    margin: 0 auto;
    padding: 20px 0;
  }
}
</style>
